import React, {useState, useEffect, useRef} from "react";
import HeaderWrapper from "./header.style";
import { UncontrolledPopover, PopoverBody, Input } from 'reactstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
    people1,
    people2,
    people3
} from "helper/constant";
import { connect } from "react-redux";
import { compose } from "redux";
import AuthActions from "redux/auth/actions";
import { withRouter } from "react-router-dom";
import PopoverBlock from './PopoverBlock'
import Select from 'react-select';
import { onlyDate } from "helper/methods";

import { setDevice } from "views/service/app/Dashboard";

const { logout } = AuthActions;
const Header = props => {
    const { drawerMiniMethod, mini } = props;
    const [notification, setNotification] = useState([]);
    const [notificationdevice, setNotificationDevice] = useState(0);

    const [notificationsettings, setNotificationSettings] = useState({
        "users": [],
        "devices": [],
    });
    const [heMAX, setHeMAX] = useState();
    const [heMIN, setHeMIN] = useState();
    const [avgMAX, setAvgMAX] = useState();
    const [avgMIN, setAvgMIN] = useState();
    const [magMAX, setMagMAX] = useState();
    const [magMIN, setMagMIN] = useState();
    const [shield1MAX, setShield1MAX] = useState();
    const [shield1MIN, setShield1MIN] = useState();
    const [shield2MAX, setShield2MAX] = useState();
    const [shield2MIN, setShield2MIN] = useState();
    const [turret1MAX, setTurret1MAX] = useState();
    const [turret1MIN, setTurret1MIN] = useState();
    const [turret2MAX, setTurret2MAX] = useState();
    const [turret2MIN, setTurret2MIN] = useState();
    const [ccr11MAX, setCcr11MAX] = useState();
    const [ccr11MIN, setCcr11MIN] = useState();
    const [ccr12MAX, setCcr12MAX] = useState();
    const [ccr12MIN, setCcr12MIN] = useState();
    const [ccr21MAX, setCcr21MAX] = useState();
    const [ccr21MIN, setCcr21MIN] = useState();
    const [ccr22MAX, setCcr22MAX] = useState();
    const [ccr22MIN, setCcr22MIn] = useState();
    const [quh1MAX, setQuh1MAX] = useState();
    const [quh1MIN, setQuh1MIN] = useState();
    const [quh2MAX, setQuh2MAX] = useState();
    const [quh2MIN, setQuh2MIN] = useState();
    const [swtMAX, setSwtMAX] = useState();
    const [swtMIN, setSwtMIN] = useState();
    const [cheadMAX, setCheadMAX] = useState();
    const [cheadMIN, setCheadMIN] = useState();

    const [pressHTRMAX, setPressHTRMAX] = useState();
    const [pressHTRMIN, setPressHTRMIN] = useState();
    const [pressstat, setPressstat] = useState();
    const [compstat, setCompstat] = useState();
    const [shstat, setShstat] = useState();
    const [eisstat, setEisstat] = useState();

    const [search, setSearch] = useState([]);
    const selectDevice = useRef('');
    const [modal, setmodal] = useState(false);

    const {
        handleChange,
    } = props;

    const userSignout = () => {

        fetch("/logout", {
            method: "POST",
        }).then(response => {
            return response.json()
        }).then(data => {
            if(data.logout){
                props.logout();
                props.history.push("/login");
            }
        })


    };

    

    useEffect(() => {
        const abortController = new AbortController();

        if (props.authData.user && (props.authData.user.authCode === 10 || props.authData.user.authCode === 15)) {

            const signal = abortController.signal
            fetch("/service/devices/searchdevices", {signal: signal})
            .then(res => res.json())
            .then(devices => {
                if(devices[0]) {
                    if(devices[0].options) {
                        if(devices[0].options[0]){
                            setDevice(devices[0].options[0])
                            setSearch(devices);
                            selectDevice.current.select.setValue(devices[0].options[0])
                        }
                    }
                }
            })

            fetch("/service/dashboard/notifications", {signal: signal})
            .then(res => res.json())
            .then(nots => {
                setNotification(nots);
            })

        }
    return function cleanup() {
        abortController.abort()
    }
    }, [])

    const formatGroupLabel = data => (
        <div style={groupStyles}>
          <span>{data.label}</span>
          <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    );

    const handleDevice = (_this) => {
        if (_this._id) {
            fetch('/service/devices/'+_this._id)
            .then(res => res.json())
            .then(device => {setDevice(device)})
        }
    }

    const handleNotificationDevice = (target, index) => {
        setNotificationDevice(index);
        var tmp = notificationsettings["devices"][index]["notifications"];

        setHeMAX(tmp[0]["max"]);
        setHeMIN(tmp[0]["min"]);
        setAvgMAX(tmp[2]["max"]);
        setAvgMIN(tmp[2]["min"]);
        setMagMAX(tmp[3]["max"]);
        setMagMIN(tmp[3]["min"]);
        setShield1MAX(tmp[4]["max"]);
        setShield1MIN(tmp[4]["min"]);
        setShield2MAX(tmp[5]["max"]);
        setShield2MIN(tmp[5]["min"]);
        setTurret1MAX(tmp[6]["max"]);
        setTurret1MIN(tmp[6]["min"]);
        setTurret2MAX(tmp[7]["max"]);
        setTurret2MIN(tmp[7]["min"]);
        setCcr11MAX(tmp[8]["max"]);
        setCcr11MIN(tmp[8]["min"]);
        setCcr12MAX(tmp[9]["max"]);
        setCcr12MIN(tmp[9]["min"]);
        setCcr21MAX(tmp[10]["max"]);
        setCcr21MIN(tmp[10]["min"]);
        setCcr22MAX(tmp[11]["max"]);
        setCcr22MIn(tmp[11]["min"]);
        setQuh1MAX(tmp[12]["max"]);
        setQuh1MIN(tmp[12]["min"]);
        setQuh2MAX(tmp[13]["max"]);
        setQuh2MIN(tmp[13]["min"]);
        setSwtMAX(tmp[14]["max"]);
        setSwtMIN(tmp[14]["min"]);
        setCheadMAX(tmp[15]["max"]);
        setCheadMIN(tmp[15]["min"]);
        setPressHTRMAX(tmp[16]["max"]);
        setPressHTRMIN(tmp[16]["min"]);
        setPressstat(tmp[20]["val"]);
        setCompstat(tmp[18]["val"]);
        setShstat(tmp[18]["val"]);
        setEisstat(tmp[17]["val"]);
        

    }


    const makerequest = () => {

        if (props.authData.user && (props.authData.user.authCode === 10 || props.authData.user.authCode === 15)) {
            fetch('/service/devices/notificationsettings')
            .then(res => res.json())
            .then(response => {
                setNotificationSettings(response);


                if(response["devices"][0]) {
                    var tmp = response["devices"][notificationdevice]["notifications"];

                    setHeMAX(tmp[0]["max"]);
                    setHeMIN(tmp[0]["min"]);
                    setAvgMAX(tmp[2]["max"]);
                    setAvgMIN(tmp[2]["min"]);
                    setMagMAX(tmp[3]["max"]);
                    setMagMIN(tmp[3]["min"]);
                    setShield1MAX(tmp[4]["max"]);
                    setShield1MIN(tmp[4]["min"]);
                    setShield2MAX(tmp[5]["max"]);
                    setShield2MIN(tmp[5]["min"]);
                    setTurret1MAX(tmp[6]["max"]);
                    setTurret1MIN(tmp[6]["min"]);
                    setTurret2MAX(tmp[7]["max"]);
                    setTurret2MIN(tmp[7]["min"]);
                    setCcr11MAX(tmp[8]["max"]);
                    setCcr11MIN(tmp[8]["min"]);
                    setCcr12MAX(tmp[9]["max"]);
                    setCcr12MIN(tmp[9]["min"]);
                    setCcr21MAX(tmp[10]["max"]);
                    setCcr21MIN(tmp[10]["min"]);
                    setCcr22MAX(tmp[11]["max"]);
                    setCcr22MIn(tmp[11]["min"]);
                    setQuh1MAX(tmp[12]["max"]);
                    setQuh1MIN(tmp[12]["min"]);
                    setQuh2MAX(tmp[13]["max"]);
                    setQuh2MIN(tmp[13]["min"]);
                    setSwtMAX(tmp[14]["max"]);
                    setSwtMIN(tmp[14]["min"]);
                    setCheadMAX(tmp[15]["max"]);
                    setCheadMIN(tmp[15]["min"]);
                    setPressHTRMAX(tmp[16]["max"]);
                    setPressHTRMIN(tmp[16]["min"]);
                    setPressstat(tmp[20]["val"]);
                    setCompstat(tmp[18]["val"]);
                    setShstat(tmp[18]["val"]);
                    setEisstat(tmp[17]["val"]);
                }
            })
        }
    }

    const changeonall = () => {
        var tmp = notificationsettings;
        var apply = tmp["devices"][notificationdevice]["notifications"];
        for(var i = 0; i < notificationsettings["devices"].length; i++) {
            tmp["devices"][i]["notifications"][0]["max"] = apply[0]["max"];
            tmp["devices"][i]["notifications"][0]["min"] = apply[0]["min"];
            tmp["devices"][i]["notifications"][2]["max"] = apply[2]["max"];
            tmp["devices"][i]["notifications"][2]["min"] = apply[2]["min"];
            tmp["devices"][i]["notifications"][3]["max"] = apply[3]["max"];
            tmp["devices"][i]["notifications"][3]["min"] = apply[3]["min"];
            tmp["devices"][i]["notifications"][4]["max"] = apply[4]["max"];
            tmp["devices"][i]["notifications"][4]["min"] = apply[4]["min"];
            tmp["devices"][i]["notifications"][5]["max"] = apply[5]["max"];
            tmp["devices"][i]["notifications"][5]["min"] = apply[5]["min"];
            tmp["devices"][i]["notifications"][6]["max"] = apply[6]["max"];
            tmp["devices"][i]["notifications"][6]["min"] = apply[6]["min"];
            tmp["devices"][i]["notifications"][7]["max"] = apply[7]["max"];
            tmp["devices"][i]["notifications"][7]["min"] = apply[7]["min"];
            tmp["devices"][i]["notifications"][8]["max"] = apply[8]["max"];
            tmp["devices"][i]["notifications"][8]["min"] = apply[8]["min"];
            tmp["devices"][i]["notifications"][9]["max"] = apply[9]["max"];
            tmp["devices"][i]["notifications"][9]["min"] = apply[9]["min"];
            tmp["devices"][i]["notifications"][10]["max"] = apply[10]["max"];
            tmp["devices"][i]["notifications"][10]["min"] = apply[10]["min"];
            tmp["devices"][i]["notifications"][11]["max"] = apply[11]["max"];
            tmp["devices"][i]["notifications"][11]["min"] = apply[11]["min"];
            tmp["devices"][i]["notifications"][12]["max"] = apply[12]["max"];
            tmp["devices"][i]["notifications"][12]["min"] = apply[12]["min"];
            tmp["devices"][i]["notifications"][13]["max"] = apply[13]["max"];
            tmp["devices"][i]["notifications"][13]["min"] = apply[13]["min"];
            tmp["devices"][i]["notifications"][14]["max"] = apply[14]["max"];
            tmp["devices"][i]["notifications"][14]["min"] = apply[14]["min"];
            tmp["devices"][i]["notifications"][15]["max"] = apply[15]["max"];
            tmp["devices"][i]["notifications"][15]["min"] = apply[15]["min"];
            tmp["devices"][i]["notifications"][16]["max"] = apply[16]["max"];
            tmp["devices"][i]["notifications"][16]["min"] = apply[16]["min"];
            tmp["devices"][i]["notifications"][20]["val"] = apply[20]["val"];
            tmp["devices"][i]["notifications"][19]["val"] = apply[19]["val"];
            tmp["devices"][i]["notifications"][18]["val"] = apply[18]["val"];
            tmp["devices"][i]["notifications"][17]["val"] = apply[17]["val"];
        } 
  
    }

    const sendchanges = () => {

        setmodal(!modal);

        return fetch('/service/devices/updatenotificationsettings', {
            method: 'PUT',
            body: JSON.stringify(notificationsettings)
        }).then(response => response.json())

    }
    const handleChangeEmailList = ({target}) => {
        if (target.checked){
           target.setAttribute('checked', true);
           var tmp = notificationsettings;
           tmp["devices"][notificationdevice]["mailList"].push(target.value);
           setNotificationSettings(tmp);
        } else {
           console.log("checked", target)
           target.removeAttribute('checked');
           var tmp = notificationsettings;
           tmp["devices"][notificationdevice]["mailList"].pop(target.value,1);
           setNotificationSettings(tmp);

        }
    }
    const handleChangeSettings = ({target}) => {
        var findkey = target.name;
        var tmp = notificationsettings;
        console.log(findkey)
        
        if(findkey === "hemax"){
            tmp["devices"][notificationdevice]["notifications"][0]["max"] = target.value;
            setHeMAX(target.value);
        } else if(findkey === "hemin"){
            tmp["devices"][notificationdevice]["notifications"][0]["min"] = target.value;
            setHeMIN(target.value);
        } else if(findkey === "avgmax"){
            tmp["devices"][notificationdevice]["notifications"][2]["max"] = target.value;
            setAvgMAX(target.value);
        } else if(findkey === "avgmin"){
            tmp["devices"][notificationdevice]["notifications"][2]["min"] = target.value;
            setAvgMIN(target.value);
        } else if(findkey === "magmax"){
            tmp["devices"][notificationdevice]["notifications"][3]["max"] = target.value;
            setMagMAX(target.value);
        } else if(findkey === "magmin"){
            tmp["devices"][notificationdevice]["notifications"][3]["min"] = target.value;
            setMagMIN(target.value);
        } else if(findkey === "sld1max"){
            tmp["devices"][notificationdevice]["notifications"][4]["max"] = target.value;
            setShield1MAX(target.value);
        } else if(findkey === "sld1min"){
            tmp["devices"][notificationdevice]["notifications"][4]["min"] = target.value;
            setShield1MIN(target.value);
        } else if(findkey === "sld2max"){
            tmp["devices"][notificationdevice]["notifications"][5]["max"] = target.value;
            setShield2MAX(target.value);
        } else if(findkey === "sld2min"){
            tmp["devices"][notificationdevice]["notifications"][5]["min"] = target.value;
            setShield2MIN(target.value);
        } else if(findkey === "trt1max"){
            tmp["devices"][notificationdevice]["notifications"][6]["max"] = target.value;
            setTurret1MAX(target.value);
        } else if(findkey === "trt1min"){
            tmp["devices"][notificationdevice]["notifications"][6]["min"] = target.value;
            setTurret1MIN(target.value);
        } else if(findkey === "trt2max"){
            tmp["devices"][notificationdevice]["notifications"][7]["max"] = target.value;
            setTurret2MAX(target.value);
        } else if(findkey === "trt2min"){
            tmp["devices"][notificationdevice]["notifications"][7]["min"] = target.value;
            setTurret2MIN(target.value);
        } else if(findkey === "ccr11max"){
            tmp["devices"][notificationdevice]["notifications"][8]["max"] = target.value;
            setCcr11MAX(target.value);
        } else if(findkey === "ccr11min"){
            tmp["devices"][notificationdevice]["notifications"][8]["min"] = target.value;
            setCcr11MIN(target.value);
        } else if(findkey === "ccr12max"){
            tmp["devices"][notificationdevice]["notifications"][9]["max"] = target.value;
            setCcr12MAX(target.value);
        } else if(findkey === "ccr12min"){
            tmp["devices"][notificationdevice]["notifications"][9]["min"] = target.value;
            setCcr12MIN(target.value);
        } else if(findkey === "ccr21max"){
            tmp["devices"][notificationdevice]["notifications"][10]["max"] = target.value;
            setCcr21MAX(target.value);
        } else if(findkey === "ccr21min"){
            tmp["devices"][notificationdevice]["notifications"][10]["min"] = target.value;
            setCcr21MIN(target.value);
        } else if(findkey === "ccr22max"){
            tmp["devices"][notificationdevice]["notifications"][11]["max"] = target.value;
            setCcr22MAX(target.value);
        } else if(findkey === "ccr22min"){
            tmp["devices"][notificationdevice]["notifications"][11]["min"] = target.value;
            setCcr22MIn(target.value);
        } else if(findkey === "quh1max"){
            tmp["devices"][notificationdevice]["notifications"][12]["max"] = target.value;
            setQuh1MAX(target.value);
        } else if(findkey === "quh1min"){
            tmp["devices"][notificationdevice]["notifications"][12]["min"] = target.value;
            setQuh1MIN(target.value);
        } else if(findkey === "quh2max"){
            tmp["devices"][notificationdevice]["notifications"][13]["max"] = target.value;
            setQuh2MAX(target.value);
        } else if(findkey === "quh2min"){
            tmp["devices"][notificationdevice]["notifications"][13]["min"] = target.value;
            setQuh2MIN(target.value);
        } else if(findkey === "swtmax"){
            tmp["devices"][notificationdevice]["notifications"][14]["max"] = target.value;
            setSwtMAX(target.value);
        } else if(findkey === "swtmin"){
            tmp["devices"][notificationdevice]["notifications"][14]["min"] = target.value;
            setSwtMIN(target.value);
        } else if(findkey === "cheadmax"){
            tmp["devices"][notificationdevice]["notifications"][15]["max"] = target.value;
            setCheadMAX(target.value);
        } else if(findkey === "cheadmin"){
            tmp["devices"][notificationdevice]["notifications"][15]["min"] = target.value;
            setCheadMIN(target.value);
        } else if(findkey === "pressmax"){
            tmp["devices"][notificationdevice]["notifications"][16]["max"] = target.value;
            setPressHTRMAX(target.value);
        } else if(findkey === "pressmin"){
            tmp["devices"][notificationdevice]["notifications"][16]["min"] = target.value;
            setPressHTRMIN(target.value);
        } else if(findkey === "pressStatON"){
            tmp["devices"][notificationdevice]["notifications"][20]["val"] = "ON";
            setPressstat(target.value);
        } else if(findkey === "pressStatOFF"){
            tmp["devices"][notificationdevice]["notifications"][20]["val"] = "OFF";
            setPressstat(target.value);
        } else if(findkey === "compstatON"){
            tmp["devices"][notificationdevice]["notifications"][19]["val"] = "ON";
            setCompstat(target.value);
        } else if(findkey === "compstatOFF"){
            tmp["devices"][notificationdevice]["notifications"][19]["val"] = "OFF";
            setCompstat(target.value);
        } else if(findkey === "shstatON"){
            tmp["devices"][notificationdevice]["notifications"][18]["val"] = "ON";
            setShstat(target.value);
        } else if(findkey === "shstatOFF"){
            tmp["devices"][notificationdevice]["notifications"][18]["val"] = "OFF";
            setShstat(target.value);
        } else if(findkey === "eisstatON"){
            tmp["devices"][notificationdevice]["notifications"][17]["val"] = "ON";
            setEisstat(target.value);
        } else if(findkey === "eisstatOFF"){
            tmp["devices"][notificationdevice]["notifications"][17]["val"] = "OFF";
            setEisstat(target.value);
        } 
        
        setNotificationSettings(tmp);
    }

    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }
    
    const groupBadgeStyles = {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    }

    const selectStyles = {
        menu: (provided, state) => ({
            ...provided,
            width: state.selectProps.width,
            borderBottom: '1px dotted pink',
            color: state.selectProps.menuColor,
            padding: 20,
          }),


        control: provided => ({
            ...provided,           
            backgroundColor: "rgba(76, 5, 255, 0)",
            borderColor: "rgba(50, 115, 220, 0)",

            
        }),

        singleValue: (provided, state) => ({
            color: "#FFFFFF",
            fontWeight: "bold", 
            display:"none"           
            
          }),

          /*
        singleValue: (provided, state) => {
          const opacity = state.isDisabled ? 0.5 : 1;
          const transition = 'opacity 300ms';
      
          return { ...provided, opacity, transition };
        }
        */
      }


    
    const userProfile = () => {

        props.history.push("/profile");

    };

    return (
        <HeaderWrapper {...props}>
            <div className="headerBack">
                <div className="flex-x align-center">
                    <div className="drawer-handle-arrow">
                        {mini ? (
                            <button
                                className="top-header-icon"
                                onClick={() => drawerMiniMethod()}
                            >
                                <i className="fas fa-bars"></i>
                            </button>
                        ) : (
                                <button
                                    className="top-header-icon"
                                    onClick={() => drawerMiniMethod()}
                                >
                                    <i className="fas fa-bars"></i>
                                </button>
                            )}
                    </div>
                    <div
                        className="mini-drawer-menu-icon"
                        onClick={() => drawerMiniMethod()}
                    >
                        <i className="fas fa-bars" />{" "}
                    </div>

                    {
                    (props.authData.user && props.authData.user.authCode === 22) &&
                    
                        <div className="pl-10 flex-1">
                            <button
                                id="notification"
                                className="top-header-icon"
                            >
                                <i className="far fa-bell"></i>
                                <div className="button-badge fs-11 demi-bold-text">
                                    3
                                </div>
                            </button>
                            <UncontrolledPopover placement="bottom-start" target="notification" className="header-popover" trigger="focus">
                                <PopoverBody className="mail-popover-body">
                                <div className="fs-13 bold-text mb-10">
                                        You have 3 Notifications.
                                    </div>
                                    <PopoverBlock
                                        people={people1}
                                        name="Juli Hacks"
                                        text="Send You a message..."
                                        created="Just Now"
                                    />
                                    <PopoverBlock
                                        people={people2}
                                        name="Scarlet JohnSon"
                                        text="Like your status..."
                                        created="22nd July 2019"
                                    />
                                    <PopoverBlock
                                        people={people3}
                                        name="Andrew Hales"
                                        text="Tagged you in his status"
                                        created="20th Jun 2019"
                                    />
                                </PopoverBody>
                            </UncontrolledPopover>
                        </div>

                    }

                    {
                    (props.authData.user && (props.authData.user.authCode === 10 || props.authData.user.authCode === 15)) &&
                    
                        <div className="pl-10">
                            <button
                                id="notification"
                                className="top-header-icon"
                            >
                                <i className="far fa-bell"></i>
                                <div className="button-badge fs-11 demi-bold-text">
                                {notification.length}
                                </div>
                            </button>
                            <UncontrolledPopover placement="bottom-start" target="notification" className="header-popover" trigger="focus">
                                <PopoverBody className="mail-popover-body">
                                <div className="fs-13 bold-text mb-10">
                                        You have {notification.length} Notifications.
                                    </div>
                                    {
                                        Array.isArray(notification) &&
                                        notification.map((not, index) => {
                                            return(
                                                <PopoverBlock
                                                key={index}
                                                name={not.name}
                                                text={not.text}
                                                created={onlyDate(not.createdAt)}
                                            />
                                            )
                                        })
                                    }
                                   
                                </PopoverBody>
                            </UncontrolledPopover>
                            </div>
                        }
                        {
                            (props.authData.user && (props.authData.user.authCode === 10 || props.authData.user.authCode === 15)) &&

                            <div className="pl-10 header-select flex-1"> 
                                <Select
                                    styles={selectStyles}
                                    ref={selectDevice}
                                    defaultValue={search[0] ? search[0].options[0] : []}
                                    options={search}
                                    onChange={handleDevice}
                                    formatGroupLabel={formatGroupLabel}
                                />
                            </div>
                        }
                    {
                    (props.authData.user && props.authData.user.authCode === 10) &&
                    <div className="pl-10">
                        <Button className="c-primary" onClick={() => {
                            makerequest()
                            setmodal(!modal)
                            }}
                        >
                            Bildirimler
                        </Button>
                        
                    </div>
                    }
                    {/*
                    <div className="pl-10">
                        <a href="#" onClick={userProfile} style={{color:"white"}}>Profil</a>
                    </div>
                    */}
                    <div className="pl-10">
                        <a href="#" onClick={userSignout} style={{color:"white"}}>Çıkış yap</a>
                    </div>

                </div>
            </div>

            <Modal
                isOpen={modal}
                toggle={() => setmodal(!modal)}
                style={{'maxWidth': '700px'}}
            >
                <ModalHeader toggle={() => setmodal(!modal)}>Bildirimler</ModalHeader>
                <ModalBody style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>

                <div className="row">
                <div className="col-md-4" style={{"marginTop": "10px", "borderTop": "2px solid"}}>
                <div style={{paddingBottom: "10px"}}>
                    <h5>
                        Cihaz
                    </h5>
                </div>
                {

                    
                    notificationsettings["devices"] &&
                    notificationsettings["devices"].map((element, index) => {

                        if (notificationdevice === index)
                        {
                            return (
                                <div
                                    key={element._id} 
                                    style={{"paddingTop": "10px", "backgroundColor":"#ff0927"}} 
                                    onClick={(e) => handleNotificationDevice(e, index)}
                                >
                                    
                                    <a href="#" style={{ "color": "#fff"}}>{element.name}</a>
                                </div>
                            )
                        }
                        else {
                            return (
                                <div key={element._id} style={{"paddingTop": "10px"}} onClick={(e) => handleNotificationDevice(e, index)}>
                                    <a href="#" >{element.name}</a>
                                </div>
                            )
                        }
                    })
                }
                </div>
                <div className="col-md-4" style={{"borderLeft": '2px solid', "borderTop": "2px solid", "marginTop" : "10px"}}>
                <div style={{paddingBottom: "10px"}}>
                    <h5>
                        Mail Listesi
                    </h5>
                </div>
                {
                    (notificationsettings["users"] !== undefined) &&
                    notificationsettings["users"].map((user, index) => {
                        if(notificationsettings["devices"][notificationdevice].mailList && notificationsettings["devices"][notificationdevice].mailList.includes(user.email)) {
                            console.log(notificationdevice+'-'+index)
                            return(
                                <div key={notificationdevice+'-'+index} style={{"paddingTop": "10px", marginLeft: "15px"}}>
                                    <label>
                                        <Input onClick={handleChangeEmailList} value={user.email} type="checkbox" checked={true} /> {user.firstname} {user.lastname}
                                    </label>
                                </div>

                            )
                        }else {
                            return(
                                <div key={notificationdevice+'-'+index} style={{"paddingTop": "10px",  marginLeft: "15px"}}> 
                                    <label>
                                        <Input onClick={handleChangeEmailList} type="checkbox" value={user.email}/> {user.firstname} {user.lastname}
                                    </label>
                                </div>
                            )
                        }

                    })
                }
                </div>
                {
                    <div className="col-md-4" style={{borderLeft: '2px solid', "borderTop": "2px solid", "marginTop" : "10px"}}>
                        <div style={{paddingBottom: "10px"}}>
                            <h5>
                                Param: Max - Min
                            </h5>
                        </div>
                        <div key="helium">
                            <label className="fs-16 medium-text">Helyum</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name="hemax"
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={heMAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name="hemin"
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={heMIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="averagepower">
                            <label className="fs-16 medium-text">Average Power</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'avgmax'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={avgMAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'avgmin'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={avgMIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="magnet">
                            <label className="fs-16 medium-text">Magnet PSI</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'magmax'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={magMAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'magmin'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={magMIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="shield1">
                            <label className="fs-16 medium-text">Shield 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'sld1max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={shield1MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'sld1min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={shield1MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>


                        <div key="shield2">
                            <label className="fs-16 medium-text">Shield 2</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'sld2max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={shield2MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'sld2min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={shield2MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>



                        <div key="turret1">
                            <label className="fs-16 medium-text">Turret 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'trt1max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={turret1MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'trt1min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={turret1MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="turret2">
                            <label className="fs-16 medium-text">Turret 2</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'trt2max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={turret2MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'trt2min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={turret2MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="carbon11">
                            <label className="fs-16 medium-text">CCR1 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr11max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr11MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr11min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr11MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="carbon12">
                            <label className="fs-16 medium-text">CCR1 2</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr12max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr12MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr12min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr12MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="carbon21">
                            <label className="fs-16 medium-text">CCR2 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr21max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr21MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr21min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr21MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="carbon22">
                            <label className="fs-16 medium-text">CCR2 2</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr22max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr22MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'ccr22min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={ccr22MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="quh1">
                            <label className="fs-16 medium-text">Quh Htr 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'quh1max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={quh1MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'quh1min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={quh1MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="quh2">
                            <label className="fs-16 medium-text">Quh Htr 2</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'quh2max'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={quh2MAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'quh2min'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={quh2MIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="swt1">
                            <label className="fs-16 medium-text">:Swt Htr 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'swtmax'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={swtMAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'swtmin'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={swtMIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="chead">
                            <label className="fs-16 medium-text">Cold Head 1</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'cheadmax'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={cheadMAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="form-control react-form-input"
                                        name={'cheadmin'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={cheadMIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="presshtr">
                            <label className="fs-16 medium-text">Press HTR</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.5"
                                        className="form-control react-form-input"
                                        name={'pressmax'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={pressHTRMAX}
                                        placeholder="Max"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        step="0.5"
                                        className="form-control react-form-input"
                                        name={'pressmin'}
                                        style={{"width": "80px"}}
                                        onChange={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={pressHTRMIN}
                                        placeholder="Min"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="pressstat">
                            <label className="fs-16 medium-text">Press Stat</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'pressStatON'}
                                        style={
                                            pressstat == "ON" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"ON"}
                                        placeholder="ON"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'pressStatOFF'}
                                        style={
                                            pressstat == "OFF" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"OFF"}
                                        placeholder="OFF"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="compstat">
                            <label className="fs-16 medium-text">Compressor Stat</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'compstatON'}
                                        style={
                                            compstat == "ON" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"ON"}
                                        placeholder="ON"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'compstatOFF'}
                                        style={
                                            compstat == "OFF" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"OFF"}
                                        placeholder="OFF"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        <div key="shstat">
                            <label className="fs-16 medium-text">SH Stat</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'shstatON'}
                                        style={
                                            shstat == "ON" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"ON"}
                                        placeholder="ON"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'shstatOFF'}
                                        style={
                                            shstat == "OFF" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"OFF"}
                                        placeholder="OFF"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>


                        <div key="eisstat">
                            <label className="fs-16 medium-text">EIS Stat</label>
                            <div className="row" style={{"marginLeft": "0px"}}>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'eisstatON'}
                                        style={
                                            eisstat == "ON" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"ON"}
                                        placeholder="ON"
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="button"
                                        className="form-control react-form-input"
                                        name={'eisstatOFF'}
                                        style={
                                            eisstat == "OFF" ? 
                                            {"width": "80px", "backgroundColor": "red"} : {"width": "80px"}}
                                        onClick={(e) => {
                                            e = handleChangeSettings(e)
                                        }}
                                        //onBlur={handleBlur}
                                        value={"OFF"}
                                        placeholder="OFF"
                                    />
                                </div>
                                
                                
                            </div>
                        </div>

                        

                    </div>

                    

                }
                </div>
                </ModalBody>
                <ModalFooter>
                    <div>
                        <Button className="c-primary" onClick={() => changeonall()}>
                            Tümüne Uygula
                        </Button>{" "}
                    </div>
                    <div>
                        <Button className="c-primary" onClick={() => sendchanges()}>
                            Uygula
                        </Button>{" "}
                        <Button className="c-secondary" onClick={() => setmodal(!modal)}>
                            Geri
                        </Button>
                    </div>

                </ModalFooter>
            </Modal>
        </HeaderWrapper>
    );
};

export default compose(
    withRouter,
    connect(
        null,
        { logout }
    )
)(Header);
